import styled from "styled-components";

const TitleItemReorder = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: bold;
  max-width: -webkit-fill-available;
`;

export default TitleItemReorder;
